import OsGridRef from "geodesy/osgridref";
import {LatLon as UtmLatLon} from "geodesy/utm";
import proj4 from "proj4";
import {GridReferenceType} from "./state-management/definitions/ProjectInformation";

const itmProjection = "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs";
const irishGridProjection = "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +ellps=mod_airy +towgs84=482.53,-130.596,564.557,-1.042,-0.214,-0.631,8.15 +units=m +no_defs +type=crs";
const wgs84Projection = "+proj=longlat +datum=WGS84 +no_defs +type=crs";

export class CoordinateTransformer {
    public static convertItmToWgs84(east: number, north: number): [number, number] {
        const output = proj4(itmProjection, wgs84Projection, [east, north]);
        return [output[1], output[0]];
    }

    public static convertProjectGridToWgs84(east: number, north: number, gridReferenceType: GridReferenceType): [number, number] {
        if (gridReferenceType === GridReferenceType.OSGB) {
            const point = new OsGridRef(east, north).toLatLon();
            return [point.lat, point.lon];
        }

        return CoordinateTransformer.convertItmToWgs84(east, north);
    }

    public static convertWgs84ToItm(lat: number, lon: number): [number, number] {
        const output = proj4(wgs84Projection, itmProjection, [lon, lat]);
        return [output[0], output[1]];
    }

    public static convertWgs84ToIrishGrid(lat: number, lon: number): [number, number] {
        const output = proj4(wgs84Projection, irishGridProjection, [lon, lat]);
        return [output[0], output[1]];
    }

    public static convertWgs84ToUtm(lat: number, lon: number): string {
        return new UtmLatLon(lat, lon).toUtm().toString();
    }
}
